<script>
export default {
    data() {
        return {
            currentItem: "",
            carouselDirection: "left"
        };
    },
    props: {
        showControl: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        isCurrent(item) {
            return item == this.currentItem;
        },
        showItem(item) {
            this.currentItem = item;
        },
        getCarouselItemClass(item) {
            if(this.isCurrent(item)){
                return 'position: relative;';
            }else{
                return 'position: absolute; top: 0px;';
            }
        },
        mySwipe(param){
            return (direction, event) => {
                if(this.$root.isMobile){
                    this.carouselDirection = direction;
                    this.$emit('swipe-item', direction);
                }
            }
        },
        getNextItem(){
            let index = 0;
            if(this.carouselDirection === 'left'){
                index = this.currentPos - 1;
                if( index < 0 ){
                    index = this.items.length - 1;
                }
            }else{
                index = this.currentPos + 1;
                if( index >= this.items.length ){
                    index = 0;
                }
            }
            let item = this.items[index];
            return item;
        },
        showPrevItem(){
            this.carouselDirection = 'left';
            let item = this.getNextItem();
            this.showItem(item);
        },
        showNextItem(){
            this.carouselDirection = 'right';
            let item = this.getNextItem();
            this.showItem(item);
        },
        playVideo(param){
            this.$emit('play-video', param);
        }
    },
    mounted () {
    },
    computed: {
        getTransitionName() {
            if(this.$root.isMobile){
                return "slide";
            }else{
                return "fade";
            }
        },
        currentPos(){
            return this.items.indexOf(this.currentItem);
        }
    },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active{
    transition: all .5s;
}
.slide-enter{
    &.left{
        -ms-transform: translate(100%,0px); /* IE 9 */
        transform: translate(100%,0px); /* Standard syntax */
    }
    &.right{
        -ms-transform: translate(-100%,0px); /* IE 9 */
        transform: translate(-100%,0px); /* Standard syntax */
    }
}
.slide-leave-to{
    &.left{
        -ms-transform: translate(-100%,0px); /* IE 9 */
        transform: translate(-100%,0px); /* Standard syntax */
    }
    &.right{
        -ms-transform: translate(100%,0px); /* IE 9 */
        transform: translate(100%,0px); /* Standard syntax */
    }
    opacity: 0;
}


.carousel-direction-control{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;

    .carousel-direction-left, .carousel-direction-right{
        cursor: pointer;
        position: absolute;
        top: 50%;
        margin-top: -3%;
    }

    .carousel-direction-left{
        left: 0px;
    }
    .carousel-direction-right{
        right: 0px;
    }
}
.carousel-control{
    .control{
        cursor: pointer;
    }
}
</style>
